/** The department's interviewers and their calendar status; one list per department, shared by Settings and the step editor. */
export const CALENDAR_INTERVIEWERS_QUERY_KEY = "careers_calendar_interviewers";
